<onwac-modal
    [title]="confirmModal.title" 
    [show]="confirmModal.isVisible"
    (callback)="close()">
    <div slot="content">
        <p class="text-center">
            {{confirmModal.text}}
        </p>
    </div>
    <div slot="footer" class="button-row full-width">
        <onwac-button (click)="close()" [text]="confirmModal.declineText" [type]="'text'" [extra_clases]="'block'"></onwac-button>
        <onwac-button (click)="accept()" (click)="confirmModal.close()" [text]="confirmModal.acceptText" [extra_clases]="'block'" ></onwac-button>
    </div>
</onwac-modal>